/** Hero slideshow aspect ratio (wide banner) */
export const HERO_ASPECT = 16 / 9;

/**
 * Focal point (0–100) from crop center — used for background-position on the hero.
 */
export function focalPointFromCrop(pixelCrop, imageWidth, imageHeight) {
  if (!pixelCrop || !imageWidth || !imageHeight) {
    return { x: 50, y: 50 };
  }
  const x = ((pixelCrop.x + pixelCrop.width / 2) / imageWidth) * 100;
  const y = ((pixelCrop.y + pixelCrop.height / 2) / imageHeight) * 100;
  return {
    x: Math.round(Math.min(100, Math.max(0, x)) * 100) / 100,
    y: Math.round(Math.min(100, Math.max(0, y)) * 100) / 100,
  };
}

export function heroBackgroundPosition(photo) {
  const x = photo?.focal_point_x ?? 50;
  const y = photo?.focal_point_y ?? 50;
  return `${x}% ${y}%`;
}

/** Same focal point string for object-position on responsive hero <img> elements. */
export function heroObjectPosition(photo) {
  return heroBackgroundPosition(photo);
}
